import { Schema as S } from "effect";

/** Static page: nothing to hold. */
export const Model = S.Struct({ page: S.Literal("NotFound") });
export type Model = typeof Model.Type;
